<template>
    <div class="big-row-tour-result-list">
        <div v-for="(item, key) in tourResultList"
             :key="key"
             :class="['card-wrap', { collapse }]">
            <div class="layer layer-1"></div>
            <div class="layer layer-2"></div>

            <div class="big-row-tour-result-item-wrap">
                <div class="big-row-tour-result-item">

                    <div class="second-block">
                        <div class="second-block-body">
                           <!--Слидер картинок отеля-->
                           <div class="slider">
                             <result-slider-new
                                     @click.self="rightModalHotelOrTourInfoRow(item, key, $event)"
                                     :defaultimage="smallImgToMedium(sliderDefaultImage[key])"
                                     :default-image-count="sliderDefaultImageCount[key]"
                                     :tour-images="imgFilterByTourKey(tourAllImages, item)"
                                     :item="item"/>
                           </div>
                          <div class="rows-container">
                              <div v-for="(item2, key2) in item.hotels" :key="key2">
                                <div :class="['main-block', {'main-block-multiple': item.hotels.length > 1}]">
                                    <div class="main-block-header">
                                      <div class="main-block-row">
                                        <div v-if="typeof getSubHotelStars(item2.Stars.Value) === 'number'" class="hotel-stars flex align-center mb-1">
                                            <div v-for="(_, key3) in getSubHotelStars(item2.Stars.Value)" :key="key3" class="mr-2">
                                                <icon name="star" width="20px" height="20px" fill="var(--yellow-color)"/>
                                            </div>
                                        </div>
                                        <div v-else class="category-string"> {{ typeof getSubHotelStars(item2.Stars.Value) === "string" ? getSubHotelStars(item2.Stars.Value) : "" }}</div>
                                        <div v-show="hasCoord(item, key2)" @click="rightModalHotelInfo(item, key, key2, true)" class="map-info align-center">
                                            <icon name="map-icon" width="12" fill="var(--primary-color)" class="mr-5"/>
                                            <span>{{getHotelCity(item, key2)}}</span>
                                        </div>
                                      </div>
                                      <div v-show="getHotelName(item)" class="hotel-name">
                                        <template v-if="isActiveHotelName(item, key2)">
                                          <a v-if="item2.Hotel.Http || item2.Http"
                                            @click.prevent="rightModalHotelInfo(item, key, key2)"
                                            :href="item2.Hotel.Http || item2.Http || ''"
                                            :title="item2.Hotel.Value"
                                            class="pointer mr-4 ellipsis">
                                            {{ item2.Hotel.Value }} {{ typeof getSubHotelStars(item2.Stars.Value) === "string" ? getSubHotelStars(item2.Stars.Value) : "" }}
                                          </a>
                                          <span v-else 
                                                @click.prevent="rightModalHotelInfo(item, key, key2)"
                                                :title="item2.Hotel.Value"
                                                class="pointer mr-4 ellipsis">
                                            {{ item2.Hotel.Value }} {{ typeof getSubHotelStars(item2.Stars.Value) === "string" ? getSubHotelStars(item2.Stars.Value) : "" }}
                                          </span>
                                        </template>
                                        <span v-else 
                                          :title="item2.Hotel.Value"
                                          class="mr-4 ellipsis">
                                          {{ item2.Hotel.Value }} {{ typeof getSubHotelStars(item2.Stars.Value) === "string" ? getSubHotelStars(item2.Stars.Value) : "" }}
                                        </span>
                                      </div>

                                      <div class="city-resort-info-wrap">
                                        <p class="city-resort-info-text ellipsis">{{ getHotelCityAndResort(item, key2) }}</p>
                                      </div>

                                      <p v-show="!getHotelName(item)"
                                        class="no-hotel-text">
                                          {{getNoHotelText(item)}}
                                      </p>
                                      <div class="features mt-5">
                                          <div class="popover-link"
                                               v-for="(item3, key3) in getHotelType(item, key2)"
                                               :key="key3"
                                               @mouseleave="hidePopover()"
                                               @mouseenter="showPopover(item3.Value, $event)">
                                               <img width="16px" height="16px" :src="getHotelTypeIcon(item3.Key)"
                                                    class="hotel-type-icon"/>
                                          </div>
                                          <div class="CO-specials align-center">
                                            <div class="popover-link"
                                                 v-for="(item3, key3) in getHotelCOAndSpecialInfo(item, key2)" :key="`${key3}_2`">
                                                <div v-if="hasCoImage(item3.id)" 
                                                     v-show="item3.title"
                                                     @mouseleave="hidePopover()"
                                                     @mouseenter="showPopover(item3.title, $event, true)"> 
                                                  <img v-if="item3.type === 1"
                                                       width="20px" height="20px"
                                                       :src="item3.src"
                                                       class="hotel-type-icon"/>
                                                  <img v-else
                                                       width="26px" height="26px"
                                                       style="margin-top: -4px"
                                                       :src="item3.src"
                                                       class="hotel-type-icon"/>
                                                </div>
                                                <div v-else-if="item3.title.length > 1"
                                                     v-show="item3.title"
                                                     @mouseleave="hidePopover()"
                                                     @mouseenter="showPopover(item3.title, $event, true)">
                                                  <img v-if="item3.type === 1"
                                                       width="20px" height="20px"
                                                       :src="item3.src"
                                                       class="hotel-type-icon"/>
                                                  <img v-else
                                                       width="26px" height="26px"
                                                       style="margin-top: -4px"
                                                       :src="item3.src"
                                                       class="hotel-type-icon"/>
                                              </div>
                                            </div>
                                          </div>
                                      </div>
                                    </div>
                                    <div class="main-block-body">
                                      <div :class="['date-map align-center mt-5', {'date-map-multiple': item.hotels.length > 1}]">
                                          <p v-show="hasHotel(item)" class="food"> {{getFood(item, item2)}} </p>
                                      </div>
                                    </div>
                              </div>
                              </div>
                          </div>
                    </div>
                        <h4 class="program-name flex"
                            :style="{background: getHotelSpecialGradient(item), color: getHotelSpecialGradient(item) ? 'var(--white-color)' : 'var(--dark-1-color)'}"
                            :title="item.Name">
                            <icon v-if="item.BookingConditions || hasTourImages(sliderDefaultImage[key])"
                                  @click.native="rightModalBooking(item.BookingConditions, item, key)"
                                  name="info" width="20px" height="20px" fill="var(--lighten-5-color)" class="mr-4 mt-1 pointer" />

                            <a v-if="item.TourUrl"
                               :href="item.TourUrl"
                               :style="{color: getHotelSpecialGradient(item) ? 'var(--white-color)' : 'var(--dark-1-color)'}"
                               target="_blank">
                              {{item.Name}}
                            </a>
                            <span v-else>
                              {{item.Name}}
                            </span>
                        </h4>
                    </div>

                    <div class="price-block">
                        <div class="date-tourist-info">
                            <p v-if="collapse"
                               @click="selectHotel(item)"
                               class="more-hotels text-center">{{getTourDate(item, true)}}</p>
                            <p v-else class="date text-center">{{getTourDate(item, true)}}</p>
                            <p class="date text-center"
                               @mouseleave="hidePopover()"
                               @mouseenter="showPopover(getAdditionalDataTitle(item), $event, false)">{{getTourDate(item, false)}}<i>{{getTravelDuration(item)}}</i></p>
                            <p class="tourist text-center">{{getTourTourist()}}</p>

                            <div class="services-list">
                                <div v-if="hasFlight(item)"
                                     class="popover-link service"
                                     @mouseleave="hidePopover()"
                                     @mouseenter="showPopover(getFlightOrHotelQuotaText(item, 1), $event)">
                                    <base-button @click.native="rightModalAviaFlight(item)"
                                                 background="transparent"
                                                 class="relative"
                                                 padding="5px">
                                        <icon name="flight" width="20px" height="20px" :fill="getServiceQuotaStatus(item, 1)"/>
                                        <!-- <div class="quota-line" :style="{backgroundColor: getServiceQuotaStatus(item, 1) }"></div> -->
                                    </base-button>
                                </div>

                                <div @mouseover="item.hoverHotelsList = true"
                                     @mouseleave="item.hoverHotelsList = false"
                                     v-if="getHotelName(item)"
                                     :class="['hotel-btn-wrap ml-4 relative', {'no-flight': !hasFlight(item)}]">
                                    <div class="popover-link service"
                                         @mouseleave="hidePopover()"
                                         @mouseenter="showPopover(getFlightOrHotelQuotaText(item, 3), $event)">
                                        <base-button @click="showHotelList(item, key)"
                                                     background="transparent"
                                                     padding="5px">
                                            <div class="relative" style="height: 20px">
                                                <p v-if="item.hotels.length > 1"
                                                   class="count">+{{item.hotels.length-1}}</p>
                                                <icon name="hotel" width="20px" height="20px" :fill="getServiceQuotaStatus(item, 3)"/>
                                            </div>
                                            <!-- <div class="quota-line" :style="{backgroundColor: getServiceQuotaStatus(item, 3) }"></div> -->
                                        </base-button>
                                    </div>
                                    <div v-if="item.showHotelsList"
                                         @mouseover="item.hoverHotelsList = true"
                                         @mouseleave="item.hoverHotelsList = false"
                                         :class="['hotel-list', {'no-flight': !hasFlight(item)}]">
                                        <div v-for="(item2, key2) in item.hotels"
                                             :key="key2"
                                             @click="rightModalHotelInfo(item, key, key2)"
                                             class="hotel-item">
                                            <p class="nowrap yellow-text-small mr-2">{{shortDate(item2.BeginDateTime)}} /</p>
                                            <p class="nowrap yellow-text-small mr-2">{{correctDurationNight(item2.DurationInNight)}} /</p>
                                            <p class="nowrap mr-2">{{item2.City.Value}} /</p>
                                            <div class="align-center">
                                                <p class="nowrap mr-2">{{item2.Hotel.Value}}</p>

                                                <div v-if="typeof getStars(item2.Stars.Value) === 'number'"
                                                     class="hotel-stars flex align-center">
                                                    <div v-for="(item3, key3) in getStars(item2.Stars.Value)"
                                                         :key="key3">
                                                        <icon name="star" width="14px" height="14px" fill="var(--yellow-color)"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-for="(item2, key2) in getServices(item)"
                                     :key="key2"
                                     :style="{'order': item2[0].order}"
                                     class="popover-link service ml-4"
                                     @mouseleave="hidePopover()"
                                     @mouseenter="showPopover(getServiceName(item2), $event)">
                                    <base-button background="transparent"
                                                 :class="{'pointer relative': item2[0].SvKey === 14 || item2[0].SvKey === 2}"
                                                 @click="serviceClick(item2)"
                                                 padding="5px">
                                        <div class="relative" style="height: 20px">
                                            <p v-show="showServiceCount(item2)" class="count">+{{item2.length-1}}</p>

                                            <icon v-if="item2[0].typeIcon === 'taxi'"
                                                  name="taxi" width="20px" height="20px" :fill="getServiceQuotaStatus(item2)"/>
                                            <icon v-else-if="item2[0].typeIcon === 'excursion'"
                                                  name="excursion" width="20px" height="20px" :fill="getServiceQuotaStatus(item2)"/>
                                            <icon v-else-if="item2[0].typeIcon === 'bus'"
                                                  name="bus" width="20px" height="20px" :fill="getServiceQuotaStatus(item2)"/>
                                            <icon v-else-if="item2[0].typeIcon === 'train'"
                                                  name="train" width="20px" height="20px" :fill="getServiceQuotaStatus(item2)"/>
                                            <icon v-else-if="item2[0].typeIcon === 'network'"
                                                  name="network" width="20px" height="20px" :fill="getServiceQuotaStatus(item2)"/>

                                        </div>
                                        <!-- <div class="quota-line" :style="{backgroundColor: getServiceQuotaStatus(item2) }"></div> -->
                                    </base-button>
                                </div>
                            </div>
                        </div>

                        <div @mouseleave="leaveList(key)"
                             @mouseenter="hoverList(key)"
                             class="buy-btn-wrap">
                            <p v-if="collapse"
                               class="more-hotels"
                               @click="selectHotel(item)">
                                {{localizeList.moreОptions}}
                            </p>
                            <p v-if="!buyListShow[key] && showTotalPrice" style="font-size: 11pt; text-align: right;">
                              {{localizeList.summaryLower}} {{ correctPrice(item.Price) }} {{getCurrencyDisplayBySettings(rate) }}
                            </p>
                            <base-button @click.native="toggleBuyList(key, item)"
                                         padding="12px 8px"
                                         :disabled="loaderButtonStatus[key]"
                                         :size="getPriceSize(item.Cost)">
                                <span v-if="!loaderButtonStatus[key]">
                                    {{ localizeList.fromPrice }} {{ correctPrice(item.Cost) }} {{ getCurrencyDisplayBySettings(rate) }}
                                    <svg v-if="hasHotel(item)" :class="{'rotate': buyListShow[key]}" width="9px"
                                         height="13px" fill="#727272">
                                        <use xlink:href="../../../assets/images/sprite.svg#angle"></use>
                                    </svg>
                                </span>
                                <base-loader v-else width="84" size="22" weight="5"/>
                            </base-button>
                        </div>
                    </div>
                </div>
                <div v-show="buyListShow[key]"
                     @mouseleave="leaveList(key)"
                     @mouseenter="hoverList(key)"
                     :class="['big-row-tour-result-sub-block', { 'cancellation' : showCancellationPolicy }, { 'isMulti': item.hotels && item.hotels.length > 1 } ]">
                    <div class="space"></div>
                    <div class="space"></div>
                    <div class="tour-program-list">
                        <div v-for="(item2, key2) in buyList[key]"
                             :key="key2"
                             class="tour-program-item-group">
                              <div v-for="(item3, key3) in item2.items"
                                  :key="key3"
                                  :class="[getWindowSettings.showQuiQuoService ? 'tour-program-item-qui-quo' : 'tour-program-item', 
                                  { 'isMulti': item.hotels && item.hotels.length > 1 },
                                  { 'isPenalty': showCancellationPolicy }]">

                                <div class="space multi" v-show="item.hotels && item.hotels.length > 1 &&
                                                                 !settings.FiltersDisplayOptions &&
                                                                 getWindowSettings.commonFiltersForHotels">
                                </div>

                                <div v-if="item.hotels && item.hotels.length > 1"
                                    :class="['multi-info-block align-center', { 'isMulti': item.hotels && item.hotels.length > 1 } ]">
                                  <p class="multi-text-open-modal" @click.prevent="rightModalHotelInfo(item, key, key3)">{{ item.hotels[key3].Hotel.Value }}</p>
                                  <span v-if="!getStars(item.hotels[key3].Stars.Value)" class="standard-text-small ml-5"> 
                                    {{ typeof getSubHotelStars(item.hotels[key3].Stars.Value) === "string" ? getSubHotelStars(item.hotels[key3].Stars.Value) : "" }}
                                  </span>
                                  <div v-else class="flex">
                                      <div v-for="(_, key4) in getSubHotelStars(item.hotels[key3].Stars.Value)"
                                        :key="key4"
                                        class="sub-hotels-starts-content">
                                        <icon name="star" width="14px" height="14px" fill="var(--yellow-color)"/>
                                      </div>
                                 </div>
                                </div>

                                <span v-if="showCancellationPolicy" v-html="getPenaltyInfo(item2.penalties)" class="standard-text-small"></span>

                                <div class="align-center">
                                  <div>
                                      <div class="mr-8"
                                         @mouseleave="hidePopover()"
                                         @mouseenter="showPopover(getQuotaText(item3, 3), $event)">
                                        <icon v-if="getBuyIconStatus(item3) === 'aviailable'"
                                              name="aviailable" width="16px" height="16px" fill="var(--white-color)" />
                                        <icon v-else-if="getBuyIconStatus(item3) === 'less'"
                                              name="less" width="16px" height="16px" fill="var(--white-color)" />
                                        <icon v-else-if="getBuyIconStatus(item3) === 'not-aviailable'"
                                              name="not-aviailable" width="16px" height="16px" fill="var(--white-color)" />
                                        <icon v-else
                                              name="request" width="16px" height="16px" fill="var(--white-color)" />
                                      </div>
                                    </div>

                                    <p class="standard-text-small">
                                        {{ item3.accomodationType + " / " + item3.roomCategory + " / " + item3.adult }}
                                    </p>
                                </div>
                                <div class="hotel-info-block align-center justify-between">
                                    <p class="hotel-info-text grey-text-small ml-6">
                                        {{ item3.pansion + (item3.pansionAdditionalInfo != null ? " / " + item3.pansionAdditionalInfo : "") }}
                                        <span v-if="item3.hotelData.CriticalInfo"> / </span>
                                        <span v-if="item3.hotelData.CriticalInfo" class="red-text">{{ localizeList[item3.hotelData.CriticalInfo] }}</span>
                                    </p>
                                    <div :class="{ 'show-price': showTotalPrice }"
                                         :style="{ 'opacity': showBuyListPrice(item2.items, key3) ? 1 : 0,
                                                   'z-index': showBuyListPrice(item2.items, key3) ? 1 : -1 }">
                                      <p v-if="showTotalPrice" style="font-size: 9pt; white-space: nowrap">
                                        {{localizeList.summaryLower}} {{ correctPrice(item2.price) }} {{getCurrencyDisplayBySettings(rate) }}
                                      </p>
                                      <base-button @click.native="buyTour(item2, key2)"
                                                   class="tour-program-list-btn show-btn"
                                                   padding="6px 8px">
                                          <icon name="basket" width="16px" height="16px" fill="var(--white-color)"/>

                                          <span class="font-small font-bold ml-3">
                                              {{correctPrice(item2.cost) }} {{ getCurrencyDisplayBySettings(rate) }}
                                          </span>
                                      </base-button>
                                    </div>
                                    <base-button style="display: none; z-index: -1"
                                                 class="tour-program-list-btn"
                                                 padding="6px 8px">
                                        <img width="16px" height="16px" src="../../../assets/images/busket.svg" alt="">
                                        <span class="font-small font-bold ml-3">
                                            {{ correctPrice(item2.cost) }} {{ getCurrencyDisplayBySettings(rate) }}
                                        </span>
                                    </base-button>

                                   
                                </div>

                                <div v-if="getWindowSettings.showQuiQuoService" class="qui-quo-block" @click.stop>
                                    <div class="qq-btn-place" :data-value="getQuiQuoJSON(item, item2, item3)">
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import resultSliderNew from "../resultSliderNew";
    import moment from "moment";
    import {bus} from "../../../main";
    import { showPenaltyAndTotalPrice, searchResultMethods } from "../../../plugins/methodsSearchResult";

    export default {
      name: "bigRowResult",
      mixins: [showPenaltyAndTotalPrice, searchResultMethods],
        components: {
            resultSliderNew,
        },
        props: {
            rate: {
                type: Object,
                required: true
            },
            COInfo: {
                type: Object,
                required: true
            },
            tourResultList: {
                type: Array,
                required: true
            },
            buyList: {
                type: Array,
                required: true
            },
            buyListShow: {
                type: Array,
                required: true
            },
            sliderDefaultImage: {
                type: Array,
                required: true
            },
            sliderDefaultImageCount: {
                type: Array,
                required: true
            },
            tourAllImages: {
                type: Array,
                required: true
            },
            buyListNotHotelKey: {
              type: Number,
              default: null
            }
        },
        data() {
            return {
                loaderButtonStatus: [],
                coInfo: {
                    coId: 0,
                    imgPath: ""
                },
                coInfoList: []
            }
        },
        computed: {
            collapse() {
                return this.$store.getters['hotels/getCollapse']
            },
            settings() {
                const settings = this.$store.getters['getSettings'];
                // settings.AutomaticLoadingResults = true;
                return settings;
            },
            getWindowSettings(){
                return window.settings
            },
        },
        mounted() {
            if (this.tourResultList.length) {
                this.coInfoList = [];
                this.getCOImages(this.tourResultList);
                this.setFeaturesMaxHeight()
            }
            this.setFeaturesMaxHeight()
        },
        methods: {
            getQuiQuoJSON(item, item2, item3) {
                const getTourDataQuiQuo = window.settings.getTourDataQuiQuo;
                const tourUrl = item.TourUrl;
                const tourName = item.Name;

                const startDate = item.StartDate.split('T')[0];
                const [year, month, day] = startDate.split('-') 
                const beginDate = `${day}.${month}.${year}`

                const { adult, childs, childAges } = this.getAdultAndChildsFromHref()

                const { names, countries, city, resort, hotelUrl } = this.getHotelQuiQuoData(item.hotels)

                const roomInfo = item3.accomodationType + " / " + item3.roomCategory + " / " + item3.adult;
                const cityAndResortString = resort ? `${city}, ${resort}` : city

                const name = getTourDataQuiQuo ? tourName : names;
                const href = getTourDataQuiQuo ? tourUrl : hotelUrl;

                let imageUrl;
                const tourKey = item.Key
                const hotelKey = item.hotels[0].Hotel.Key
                const isTourImage = this.sliderDefaultImage.find(x => x.includes(`code=${tourKey}`))
                const isHotelImage = this.sliderDefaultImage.find(x => x.includes(`code=${hotelKey}`))
                if (getTourDataQuiQuo && isTourImage) {
                  imageUrl = isTourImage
                } else if (!getTourDataQuiQuo && !isHotelImage) {
                  imageUrl = isTourImage
                } else {
                  imageUrl = isHotelImage
                }

                const QuiQuoObject = {
                    checkinDt: beginDate,
                    nights: String(item.DurationInNight),
                    hotelName: name,
                    roomType: roomInfo,  
                    boardType: item3.pansion,
                    price: item2.cost,
                    currency: item.rate?.IsoCode || this.getCurrencyFromHref(),
                    city_from: item.CityDepature.Value,
                    occupancy: {
                    adultsCount: parseInt(adult),
                    childrenCount: childs || 0,
                    childAges: childAges || 0,
                    },
                    region: cityAndResortString,
                    country: countries,
                    thumbnail: imageUrl || "",
                    href
                }

                return JSON.stringify(QuiQuoObject)
            },
            getCurrencyFromHref(){
                let currency;
                location.href.split('&').forEach(x => {
                    if (x.includes('currency')) {
                    currency = x.split('=')[1]
                    }
                });
                return currency
            },
            getAdultAndChildsFromHref(){
                let adult = null;
                let childs = null;
                let childAges = null;

                location.href.split('&').forEach(x => {
                    if (x.includes('adultCount')) {
                    adult = x.split('=')[1]
                    }
                    if (x.includes('childAges')) {
                    childAges = x.split('=')[1]
                    }
                    if (x.includes('childAges')) {
                    childs = x.split('=')[1].split(',').length
                    }
                });

                return {
                    adult,
                    childs,
                    childAges
                }
            },
            getHotelQuiQuoData(hotels){
                const names = hotels.map(item => item.Hotel.Value).join(", ")
                const hotelUrl = hotels[0].Http
                const countries = hotels[0].Country.Value
                const city = hotels[0].City.Value
                const resort = hotels[0].Resort.Value
                const rooms = hotels.map(item => {
                    return item.HotelDetails.map(subitem => subitem.Room.Value).join(', ')
                }).join(', ')

                return { names, countries, city, resort, rooms, hotelUrl }
            },
            setFeaturesMaxHeight() {
                const maxHeight = this.tourResultList.length
                for (let i = 0; i < maxHeight; i++) {
                    this.loaderButtonStatus.push(false)
                }
            },
            hasTourImages(url) {
                return url?.includes("tours")
            },
            selectHotel(item) {
                const hotelKeys = item.hotels.map(x => x.Hotel.Key);
                bus.$emit("tour_selectHotel_hotels", hotelKeys);
                bus.$emit("hotels_collapse", false);
            },
            hoverList(val) {
                this.$emit("hoverList", val)
            },
            leaveList(val) {
                this.$emit("leaveList", val)
            },
            serviceClick(item) {
                this.$emit("serviceClick", item)
            },
            rightModalAviaFlight(item) {
                this.$emit("rightModalAviaFlight", item)
            },
            buyTour(item, key) {
                this.$emit("buyTour", [item, key])
            },
            toggleBuyList(item, key) {
                this.loaderButtonStatus[item] = true
                this.$emit("toggleBuyList", [item, key])
            },
            rightModalHotelInfo(item, key, key2, scrollToMap = false) {
                if (key2 === null) {
                  let searchIndexHotelNoCoord = item.hotels.findIndex((x) => x.Latitude && x.Longitude)
                  key2 = searchIndexHotelNoCoord !== -1 ? searchIndexHotelNoCoord : 0;
                }
                let viewRemoteHotels = this.settings.ViewRemoteHotels;
                if (viewRemoteHotels) {
                    let hotels = item.Services.filter(x => x.SvKey === 3);
                    if (hotels.length > 0) {
                        if (hotels[key2].Http !== null && hotels[key2].Http !== "") {
                            window.open(hotels[key2].Http, '_blank');
                        } else {
                            this.$emit("rightModalHotelInfo", [item, key, key2, scrollToMap]);
                        }
                    } else {
                        this.$emit("rightModalHotelInfo", [item, key, key2, scrollToMap])
                    }
                } else {
                    this.$emit("rightModalHotelInfo", [item, key, key2, scrollToMap])
                }
            },
            rightModalBooking(html, item, key) {
                this.$emit("rightModalBooking", [html, item, key])
            },
            isActiveHotelName(item, key2){
                let doNotShowEmptyHotelCards = this.settings.DoNotShowEmptyHotelCards;
                if (doNotShowEmptyHotelCards) {
                    let hotels = item.Services.filter(x => x.SvKey === 3);
                    if (hotels.length > 0) {
                        let viewRemoteHotels = this.settings.ViewRemoteHotels;
                        if (viewRemoteHotels) {
                            return hotels[0].hasImages || (hotels[0].http !== null && hotels[0].http !== "");
                        }
                        return hotels[key2].hasImages;
                    }
                }
                return true;
            },
            getPriceSize(cost) {
                return cost > 999999 ? 14 : 16
            },
            hasCoord(item, key2, showFirst = false) {
                if (showFirst && item.coordinates?.length) {
                  return this.hasHotel(item);
                } else if(showFirst && !item.coordinates?.length) {
                  return item.hotels.some((x) => x.Latitude && x.Longitude);
                } else {
                  return item.hotels[key2]?.Latitude && item.hotels[key2]?.Longitude;
                }
            },
            hasHotel(item) {
                return item.Services.some(x => x.SvKey === 3);
            },
            hasFlight(item) {
                return item.Services.map(x => x.SvKey).includes(1)
            },
            getHotelName(item) {
                let hotel = item.Services.filter(x => x.SvKey === 3);
                if (!hotel.length) return "";

                return hotel[0].Hotel.Value;
            },
            getHotelCity(item, key2, showFirst = false) {
                const hotels = item.Services.filter(x => x.SvKey === 3);
                if (!hotels.length) return "";
                if (showFirst && item.coordinates) {
                  return hotels[0].City.Value;
                } else if (showFirst && !item.coordinates) {
                  return item.hotels.find((x) => x.Latitude && x.Longitude)?.City.Value || hotels[0].City.Value;
                } else {
                  return hotels[key2]?.City.Value;
                }
            },
            getHotelCityAndResort(item, key) {
                const hotels = item.Services.filter(x => x.SvKey === 3);
                if (!hotels.length) return "";

                const checkCityWithResort = (city, resort) => {
                const equal = city?.toLowerCase() === resort?.toLowerCase();
                  if (city && resort && !equal) {
                    return city + "/" + resort;
                  } else {
                    return city;
                  }
                };

                return checkCityWithResort(hotels[key]?.City.Value, hotels[key]?.Resort.Value);
            },
            getHotelHref(item) {
                return item.Services.find(x => x.SvKey === 3)?.Http || ''
            },
            getSubHotelStars(value) {
                return  this.getStars(value) ? this.getStars(value) : value;
            },
            getHotelStars(item) {
                let res = 0;
                let hotel = item.Services.filter(x => x.SvKey === 3);
                if (!hotel.length) return "";

                res = this.getStars(hotel[0].Stars.Value) ? this.getStars(hotel[0].Stars.Value) : hotel[0].Stars.Value;

                return res;
            },
            getStars(val) {
                if (!val) {
                    return val
                }
                let res = 0;
                let stars = parseInt(val[0]);
                if (typeof stars === "number" && !isNaN(stars)) {
                    res = stars
                }
                return res
            },
            getNoHotelText(item) {
                let cityTo = item.Services.find(x => x.CityTo);
                cityTo = cityTo ? cityTo.CityTo.Value : item.CityDepature.Value;
                return cityTo + ", " + this.getTourDuration(item, true)
            },
            getTourDate(item, isDate) {
                if (this.collapse && isDate) {
                    return this.localizeList.moreDate;
                }

                const startDate = this.correctDate(item.StartDate);
                let endDate = null;
                if (item.Services.length) {
                    endDate = this.correctDate(item.Services[item.Services.length-1].EndDateTime);
                }
                const durationInNight = item.DurationInNight + " " + this.getDayLocal(item.DurationInNight, 'night');

                return isDate ? startDate + (endDate ? ` – ${endDate}` : '') : `${durationInNight}`;
            },
            getTourTourist() {
                let adult = null;
                let child = null;
                location.href.split('&').forEach(x => {
                    if (x.includes('adultCount')) {
                        adult = x.split('=')[1]
                    }
                    if (x.includes('childAges')) {
                        child = x.split('=')[1].split(',').length
                    }
                });
                adult = adult + " " + this.getTouristLocal(+adult, 'adult').toLowerCase();
                if (!child) return adult;

                child = child + " " + this.getTouristLocal(child, 'child').toLowerCase();
                return `${adult}, ${child}`
            },
            getTouristLocal(count, type) {
                if (count === 1) {
                    return this.localizeList[type]
                } else if (type === 'child') {
                    return this.localizeList.children
                } else {
                    return this.localizeList[type+"s2"]
                }
            },
            getTourDuration(item, checkNight = false) {
                const duration = item.Duration + " " + this.getDayLocal(item.Duration, 'day');
                const durationInNight = item.DurationInNight + " " + this.getDayLocal(item.DurationInNight, 'night');

                if (checkNight && !item.DurationInNight) {
                    return duration;
                }
                return `${duration} (${durationInNight})`;
            },
            getTravelDuration(item) {
                const durationTravel = (item.Duration || 0)-(item.DurationInNight || 0)-1;
                let durationTravelText = durationTravel > 0 ? ` +${durationTravel}` : '';

                return `${durationTravelText}`;
            },
            getAdditionalDataTitle(item) {
                const durationTotal = item.Duration - 1;
                const durationTravel = durationTotal - item.DurationInNight;

                const firstTitleText = this.localizeList['daysNightsTourDuration'];
                const titleText = this.localizeList['daysNightsHotelAndTravel'];
                let itemHotel = '';
                let itemTravel = '';
                let itemDuration = '';
                itemHotel = this.getDayLocal(item.DurationInNight, 'night');
                itemTravel = this.getDayLocal(durationTravel, 'night');
                itemDuration = this.getDayLocal(item.Duration, 'day');

                let newStr = '';
                if (durationTravel <= 0) {
                  newStr = `${firstTitleText.replace('{0}', item.Duration).replace('{1}', itemDuration).replace('{2}', item.DurationInNight).replace('{3}', itemHotel)}`
                } else {
                  newStr = `${firstTitleText.replace('{0}', item.Duration).replace('{1}', itemDuration).replace('{2}', item.DurationInNight).replace('{3}', itemHotel)}
                            ${titleText.replace('{0}', item.DurationInNight).replace('{1}', itemHotel).replace('{2}', durationTravel).replace('{3}', itemTravel)}`;
                }

              return newStr
            },
            getDayLocal(day, type) {
                if (day === 1) {
                    return this.localizeList[type]
                } else if (day < 5 && day > 1) {
                    return this.localizeList[type+"2"]
                } else {
                    return this.localizeList[type+"s"]
                }
            },
            getFood(item, item2) {
                if(item.hotels.length > 1 && item2.HotelDetails.length === 1) {
                let result =
                  `${item2.HotelDetails[0].AccomodationType.Value} / ${item2.HotelDetails[0].RoomCategory.Value} /
                    ${item2.HotelDetails[0].Pansion.Value +
                    (item2.HotelDetails[0].PansionAdditionalInfo != null ? " / " + item2.HotelDetails[0].PansionAdditionalInfo : "")}
                  `
                return result
                } else {
                const hotel = item.Services.filter(x => x.SvKey === 3);
                if (!hotel.length) return "";
                const pansion = item.MinCostServicesComposition.find(x => x.Value.ServiceType === 3) || item.MinCostServicesComposition[0];
                const pansionKey = pansion.Value.SubCode2;
                const hotelDetail = hotel[0].HotelDetails.find(x => x.Pansion.Key === pansionKey) || hotel[0].HotelDetails[0];

                return  `${hotelDetail.AccomodationType.Value} / ${hotelDetail.RoomCategory.Value} / ${hotelDetail.Pansion.Value + (hotelDetail.PansionAdditionalInfo != null ? " / " + hotelDetail.PansionAdditionalInfo : "")}`;
                }
            },
            getHotelType(item, key) {
                const hotel = item.Services.filter(x => x.SvKey === 3);
                if (!hotel.length) return "";

                return hotel[key].HotelTypes;
            },
            getHotelTypeIcon(key) {
                let path = this.$store.getters['getPath'];
                return `${this.$store.getters['getApiOrigin']}${path}/GetImage/GetImage?type=hotelType&id=${key}&width=20&height=20`
            },
            getFlightOrHotelQuotaText(item, svKey) {
                const quotaServices = this.$store.getters['getQuotaServices'].map(x => x.Key);
                if (!quotaServices.includes(svKey)) {
                    return ""
                }
                let priority = 4;
                let res = "";

                const services = item.Services.filter(x => x.SvKey === svKey);

                services.forEach(x => {
                    const details = svKey === 1 ? x.FlightDetails[0] : x.HotelDetails[0];
                    const quota = details.quotaStatus || details.QuotaStatus;

                    res = svKey === 1 ? this.localizeList.flight : this.localizeList.accommodation;
                    if (quota.PlacesStatus === 4 && priority >= 1) {
                        res += ` (${this.localizeList.onRequest.toLowerCase()})`;
                        priority = 1
                    } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0 && priority >= 2) {
                        const placesLeft = quota.FreePlaces === 1 ? 'placesLeft1' : (quota.FreePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
                        res += ` (${this.localizeList[placesLeft].replace("{}", quota.FreePlaces).toLowerCase()})`;
                        priority = 2
                    } else if (quota.PlacesStatus === 1 && priority >= 3) {
                        res += ` (${this.localizeList.available.toLowerCase()})`;
                        priority = 3
                    } else if (quota.PlacesStatus === 2 && priority === 4) {
                        res += ` (${this.localizeList.quotaHasNoPlaces.toLowerCase()})`;
                    }
                });

                return res
            },
            getHotelSpecialGradient(item) {
                let res = "";
                const hotel = item.Services.filter(x => x.SvKey === 3);

                if (!hotel.length) return res;

                let specialInfo = hotel[0].COAndSpecialsInfo.AppliedSpeciasInfo?.AppliedSpeciasInfo;
                if (specialInfo) {
                    // specialInfo.forEach(x => {
                    //     console.log(x);
                    // });
                    // if (specialInfo[0].SpecialType === "PayStay")
                    //     res = "linear-gradient(90deg, rgba(255, 28, 28, 0.6) 10.93%, rgba(255, 28, 28, 0.5) 46.36%, rgba(196, 196, 196, 0) 100.31%)";
                    // if (specialInfo[0].SpecialType === "KickBack")
                    //     res = "linear-gradient(90deg, rgba(255, 215, 111, 0.5) 10.93%, rgba(255, 244, 142, 0.864583) 46.36%, rgba(196, 196, 196, 0) 100.31%)";
                    // if (specialInfo[0].SpecialType === "EarlyBird")
                    //     res = "linear-gradient(90deg, rgba(31, 168, 28, 0.5) 10.93%, rgba(183, 255, 158, 0.864583) 46.36%, rgba(196, 196, 196, 0) 100.31%)";
                }

                return res
            },
            hasCoImage(id) {
                return this.coInfoList.some(x => x.coId == id);
            },
            // получаем пути картинок ЦБ
            getCOImages(tours) {
                const path = `${this.$store.getters['getApiOrigin']}${this.$store.getters['getPath']}`;

                const keys = tours.flatMap(tour =>
                    tour.Services
                        .filter(service => service?.SvKey === 3)
                        .flatMap(service => service?.COAndSpecialsInfo || [])
                        .flatMap(info => info?.AppliedCostOffersKeys || [])
                        .filter(key => key != null)
                );
                // получаем пути иконок
                if (keys.length > 0) {
                    this.$store.dispatch('tour/A_GET_CO_IMAGES', { Path: path, Keys: keys })
                        .then(res => {
                            if (res?.data) {
                                // Обновляем список с информацией о путях иконок
                                this.coInfoList = res.data.map(item => ({
                                    coId: item.Key,
                                    imgPath: item.Value
                                }));
                            }
                        })
                        .catch(error => {
                            console.error('Ошибка при получении путей изображений:', error);
                        });
                    }
            },
            getHotelCOAndSpecialInfo(item, key) {
                const res = [];
                const hotel = item.Services.filter(x => x.SvKey === 3);
                const index = key;
                const path = `${this.$store.getters['getApiOrigin']}${this.$store.getters['getPath']}`;
                const transfers = item.Services.filter(x => x.SvKey === 2);

                if (!hotel.length) return res;

                let COKeys = hotel[index].COAndSpecialsInfo.AppliedCostOffersKeys;
                if (this.COInfo.costOffersImageInformation) {
                    this.COInfo.costOffersImageInformation.filter(x => {
                        if (COKeys && COKeys.includes(x.IdCostOffer)) {
                            res.push({
                                id: x.IdCostOffer,
                                type: 1,
                                title: x.InfoText,
                                src: `${path}/GetImage/GetCostOfferFile?&id=${x.IdCostOffer}&width=50&height=50&text=${!!x.InfoText}`
                            })
                        }
                    });
                }

                let specialInfo = hotel[index].COAndSpecialsInfo.AppliedSpeciasInfo?.AppliedSpeciasInfo;
                if (specialInfo) {
                    specialInfo.forEach(x => {
                        const title = this.$store.getters['hotels/getSpecialText'](x, this.localizeList);
                        const src = `${path}/GetImage/GetSpecialsImage?specialType=${x.SpecialType}&width=100&height=100`;
                        const isInclude = res.map(x2 => `${x2.title}${x2.src}`).includes(`${title}${src}`);
                        if (isInclude) return;

                            res.push({
                                id: x.IdCostOffer,
                                type: 2,
                                title,
                                src
                            })
                    });
                }

                if (transfers.length) {
                    transfers.forEach(x => {
                        let spInfo = x.COAndSpecialsInfo.AppliedSpeciasInfo?.AppliedSpeciasInfo;
                        if (spInfo) {
                            spInfo.forEach(si => {
                                const title = this.$store.getters['hotels/getSpecialText'](si, this.localizeList);
                                const src = `${path}/GetImage/GetSpecialsImage?specialType=${si.SpecialType}&width=100&height=100`;
                                const isInclude = res.map(x2 => `${x2.title}${x2.src}`).includes(`${title}${src}`);
                                if (isInclude) return;

                                res.push({
                                    id: x.IdCostOffer,
                                    type: 2,
                                    title,
                                    src
                                })
                            });
                        }
                    });
                }

                return res;
            },
            showServiceCount(service) {
                if (service[0].SvKey === 2 || service[0].SvKey === 14 || service[0].SvKey === 15) {
                    return false
                }
                return service.length > 1
            },
            getServiceName(service) {
                let quota = this.getQuotaTextOfServices(service);
                return this.localizeList[service[0].local] + (quota ? ` (${quota.toLowerCase()})` : '')
            },
            getQuotaTextOfServices(service) {
                const quotaServices = this.$store.getters['getQuotaServices'].map(x => x.Key);
                let helper = false;
                service.forEach(x => {
                    if (!quotaServices.includes(x.SvKey)) {
                        helper = true
                    }
                });
                if (helper) return "";

                let res = "";
                let priority = 4;
                service.forEach(x => {
                    const details = x.Details || x.BusTransferDetails || x.RailwayTransferDetails;
                    const quota = details[0].QuotaStatus;

                    if (quota.PlacesStatus === 4 && priority >= 1) {
                        res = this.localizeList.onRequest;
                        priority = 1
                    } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0 && priority >= 2) {
                        const placesLeft = quota.FreePlaces === 1 ? 'placesLeft1' : (quota.FreePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
                        res = this.localizeList[placesLeft].replace("{}", quota.FreePlaces);
                        priority = 2;
                    } else if (quota.PlacesStatus === 1 && priority >= 3) {
                        res = this.localizeList.available;
                        priority = 3;
                    } else if (quota.PlacesStatus === 2 && priority === 4) {
                        res = this.localizeList.quotaHasNoPlaces
                    }
                });

                return res
            },
            getServices(item) {
                let res = [];
                const notRouteServices = item.NotRouteServices.flat();
                const allServices = [...notRouteServices, ...item.Services];
                allServices.forEach(x => {
                    if (x.SvKey !== 1 && x.SvKey !== 3 && !x.IsHooded) {
                        if (x.SvKey === 2) {
                            x.tourName = item.Name;
                            x.typeIcon = "taxi";
                            x.local = "transfer";
                            x.order = 1;
                        } else if (x.SvKey === 4) {
                            x.typeIcon = "excursion";
                            x.local = "excursionsUpper";
                            x.order = 2;
                        } else if (x.SvKey === 14) {
                            x.tourName = item.Name;
                            x.typeIcon = "bus";
                            x.local = "busTransfer";
                            x.order = 0;
                        // } else if (x.SvKey === 6 || x.SvKey === 5) {
                        //     return;
                        } else if (x.SvKey === 15) {
                            x.tourName = item.Name;
                            x.typeIcon = "train";
                            x.local = "railwayTransfer";
                            x.order = 0;
                        } else {
                            x.typeIcon = 'network';
                            x.local = "tourProgram";
                            x.order = 5;
                        }

                        const isChecked = !x.IsNotCalculate || !x.IsDeleted;
                        if (!isChecked) return;

                        const index = res.map(x2 => x2.some(x3 => x3.local === x.local)).indexOf(true);
                        if (index === -1) {
                            res.push([x])
                        } else {
                            res[index].push(x)
                        }
                    }
                });

                const hasHotel = this.getHotelName(item);
                const hasFlight = this.hasFlight(item);

                // Проветряем если услуг больше 6 убираем экскурсию
                if (hasHotel && hasFlight && res.length > 4) {
                    res = res.filter(x => x[0].SvKey !== 4);
                }

                return res
            },
            rightModalHotelOrTourInfoRow(item, key, e) {
                let doNotShowEmptyHotelCards = this.settings.DoNotShowEmptyHotelCards;
                if(doNotShowEmptyHotelCards){
                    let hotels = item.Services.filter(x => x.SvKey === 3);
                    if(hotels.length > 0){
                        if(!hotels[0].HasImages){
                            return;
                        }
                    }
                }
                this.$emit("rightModalHotelOrTourInfo", [item, key, e])
            },
            smallImgToMedium(url) {
                if (!url) return;

                return url.replace('small160x90', 'medium')
            },
            imgFilterByTourKey(images, item) {
                let path = this.$store.getters['getPath'];

                return images
                    .filter(x => x.TourKey === item.Key)
                    .map(x => {
                        return `${this.$store.getters['getApiOrigin']}${path}/Image/GetImage?code=${x.TourKey ? x.TourKey : 639}&type=medium&name=${x.Name}&imageType=tours`;
                    })
            },
            getServiceQuotaStatus(item, svKey = null) {
                let res = '#BEBEBE';
                let priority = 4;

                const quotaServices = this.$store.getters['getQuotaServices'].map(x => x.Key);

                const data = svKey !== null ? item.Services.filter(x => x.SvKey === svKey) : item;
                data.forEach(x => {
                    if (!quotaServices.includes(x.SvKey)) {
                        priority = 0
                    }
                });

                data.forEach(x => {
                    const detail = x.FlightDetails ||
                        x.HotelDetails ||
                        x.BusTransferDetails ||
                        x.RailwayTransferDetails ||
                        x.Details;

                    if (!detail) {
                        priority = 0
                    }

                    if (detail[0] != 'undefined' && detail[0] != null ) {
                        const quota = detail[0].QuotaStatus;
                        if (quota.PlacesStatus === 4 && priority >= 1) {
                            res = "var(--yellow-color)";
                            priority = 1
                        } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0 && priority >= 2) {
                            res = "var(--primary-color)";
                            priority = 2
                        } else if (quota.PlacesStatus === 1 && priority >= 3) {
                            res = "#4ACA7F";
                            priority = 3
                        } else if (quota.PlacesStatus === 2 && priority === 4) {
                            res = "#ff0000";
                        }
                    }
                });

                return res
            },
            shortDate(date) {
                let res = date.split("T")[0].split("-").reverse().join(".");
                res = moment(date).format("DD MMM");
                return res
            },
            correctDurationNight(n) {
                if (n <= 1)
                    return n +" "+ this.localizeList.night;
                else if (n < 5)
                    return  n +" "+ this.localizeList.night2;
                else
                    return  n +" "+ this.localizeList.nights;
            },
            showHotelList(item, key) {
                if (item.hotels.length > 1) {
                    item.showHotelsList = !item.showHotelsList
                } else {
                    this.rightModalHotelInfo(item, key)
                }
            },
            getCurrencyDisplayBySettings(rate){
                return this.$store.getters['getCurrencyDisplayBySettings'](rate);
            },
            showBuyListPrice(items, key) {
                return Math.floor(items.length / 2) === key
            },
            getBuyIconStatus(item) {
                const quota = item.quotaStatus || item.QuotaStatus;
                if (quota.PlacesStatus === 1 && quota.FreePlaces === 0) {
                    return "aviailable"
                } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
                    return "less"
                } else if (quota.PlacesStatus === 4) {
                    return "request"
                } else if (quota.PlacesStatus === 2) {
                    return "not-aviailable"
                }
            },
            getQuotaText(item, svKey) {
                const quotaServices = this.$store.getters['getQuotaServices'].map(x => x.Key);
                if (!quotaServices.includes(svKey)) {
                    return ""
                }

                const quota = item.quotaStatus || item.QuotaStatus;
                let res = null;
                if (quota.PlacesStatus === 4) {
                    res = this.localizeList.onRequest
                } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
                    const placesLeft = quota.FreePlaces === 1 ? 'placesLeft1' : (quota.FreePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
                    res = this.localizeList[placesLeft].replace("{}", quota.FreePlaces);
                } else if (quota.PlacesStatus === 2) {
                    res = this.localizeList.quotaHasNoPlaces
                } else {
                    res = this.localizeList.available
                }
                return res
            },
            showPopover(text, e, nowrap = true) {
              if (!text || text.length == 0) return;

                let rect = e.target.getBoundingClientRect()
                let res = {
                    x: rect.left + (rect.width / 2),
                    y: rect.top,
                    text: text?.replaceAll('\n', '<br>'),
                    height: rect.height,
                    nowrap
                };
                this.$store.dispatch('A_SHOW_POPOVER', res)
            },
        },
        watch: {
          tourResultList: {
            deep: true,
            handler() {
                this.coInfoList = [];
                this.getCOImages(this.tourResultList);
                this.setFeaturesMaxHeight();
            }
          },
          buyListShow: {
            deep: true,
            handler(val) {
              const getActiveIndex = val.indexOf(true)
              this.loaderButtonStatus[getActiveIndex] = false
            }
          },
          buyListNotHotelKey(val) {
            if (val === null) return
            this.loaderButtonStatus[val] = false
            this.$emit('resetBuyListNotHotelKey') // Сбрасываем buyListNotHotelKey, чтобы при повторном клике наблюдатель отрабатывал
          }
        }
    }
</script>

<style scoped>
    .big-row-tour-result-list .services-list {
        display: flex;
        width: 184px;
        justify-content: center;
    }

    .big-row-tour-result-list /deep/ .base-button,
    .big-row-tour-result-list .services-list /deep/ .hover-effect {
        cursor: default;
    }
    .big-row-tour-result-list .services-list .pointer /deep/ .hover-effect {
        cursor: pointer;
    }
    .big-row-tour-result-list /deep/ .hover-effect:hover,
    .big-row-tour-result-list /deep/ .base-button:hover .hover-effect {
        opacity: 0;
    }

    .big-row-tour-result-list .count {
        position: absolute;
        /*top: -12px;*/
        top: -11px;
        left: 50%;
        transform: translateX(-50%);
        /*font-size: 12px;*/
        font-size: 10px;
        text-align: center;
        font-weight: bold;
        color: var(--lighten-5-color);
    }

    .hotel-list {
        position: absolute;
        bottom: 140px;
        right: 10px;
        left: 60px;
        background: var(--dark-1-color);
        border-radius: 6px;
        padding: 6px 0 33px;
    }
    .hotel-list.no-flight {
        left: 10px;
    }
    .qui-quo-block {
        margin-left: 12px;
        margin-bottom: 4px;
    }
    .hotel-list::after {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 16px;
        border-top: 10px solid var(--dark-1-color);
        border-right: 10px solid transparent;
        border-left: 10px solid transparent;
    }
    .hotel-list .hotel-item {
        padding: 12px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        border-bottom: 1px dashed rgba(255, 255, 255, 0.1);
        cursor: pointer;
        transition: all .2s;
        font-size: 13px;
        line-height: 18px;
        color: var(--white-color);
    }
    .hotel-list .hotel-item:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }
    .big-row-tour-result-list .hotel-list {
        bottom: 55px;
        left: unset;
        right: -8px;
        z-index: 100;
    }

    .big-row-tour-result-list .hotel-list::after {
        left: unset;
        right: 20px;
    }
    .big-row-tour-result-list {
        display: grid;
        grid-gap: 15px;
    }

    .big-row-tour-result-item-wrap {
        /*margin-bottom: 4px;*/
    }

    .big-row-tour-result-list .card-wrap {
        position: relative;
    }
    .big-row-tour-result-list .card-wrap .layer {
        display: none;
    }
    .big-row-tour-result-list .card-wrap.collapse .layer {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
        border-radius: 6px;
        background-color: var(--white-color);
    }
    .big-row-tour-result-list .card-wrap.collapse .layer-1 {
        /*background: var(--lighten-4-color);*/
        transform: translate(3px, 2px);
        z-index: 1;
    }
    .big-row-tour-result-list .card-wrap.collapse .layer-2 {
        /*background: var(--lighten-7-color);*/
        transform: translate(6px, 4px);
        z-index: 0;
    }

    .big-row-tour-result-item {
        background-color: var(--white-color);
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
        border-radius: 6px;
        display: flex;
        max-width: calc(100vw - 120px);
        /*min-width: 100%;*/
        position: relative;
        z-index: 2;
    }

    .second-block {
        /*padding: 10px 15px;*/
        flex: 4;
    }

    .second-block .second-block-body{
        display: flex;
    }

    .second-block .slider {
        cursor: pointer;
    }

    .second-block .main-block-row {
        display: flex;
        column-gap: 10px;
    }

    .second-block .main-block-row .category-string {
        font-weight: 300;
        color: var(--dark-1-color);
    }

    .second-block .program-name {
        font-size: 20px;
        line-height: 23px;
        color: var(--dark-1-color);
        padding: 10px 13px;
        background: linear-gradient(180deg, rgba(211, 111, 111, 0.1) 0%, rgba(39, 174, 96, 0.1) 100%);
        font-weight: normal;
        border-radius: 0 0 0 6px;
    }

    .second-block .slider {
        max-width: 377px;
        min-width: 250px;
        flex: 1;
        height: 250px;
        background-color: #eeeeee;
    }

    .second-block .rows-container {
        flex: 2;
        border-bottom: 1px dashed var(--lighten-7-color);
    }

    .map-info span {
        font-weight: 300;
        font-size: 14px;
        line-height: 16px;
        text-decoration-line: underline;
        color: var(--dark-1-color);
        cursor: pointer;
    }

    .main-block {
        padding: 13px 26px;
    }

    .main-block .hotel-name a,
    .main-block .hotel-name span {
        font-weight: 300;
        font-size: 24px;
        line-height: 32px;
        text-decoration-line: underline;
        color: #1C88D6;
    }

    .main-block .city-resort-info-wrap {
        overflow: hidden;
    }

    .main-block .city-resort-info-text {
        font-weight: 300;
        font-size: 13px;
        line-height: 16px;
        color: var(--dark-1-color);
    }

    .main-block .food {
        max-width: 340px;
        font-weight: 300;
        font-size: 14px;
        line-height: 16px;
        color: var(--dark-1-color);
    }

    .price-block {
        flex: 1;
        min-width: 250px;
        padding: 18px 38px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
        border-left: 1px dashed var(--lighten-7-color);
    }

    .price-block .date-tourist-info .date {
        font-weight: 300;
        font-size: 18px;
        line-height: 24px;
        color: var(--dark-1-color);
    }

    .price-block .date-tourist-info .tourist {
        font-weight: 300;
        font-size: 16px;
        line-height: 20px;
        color: var(--dark-1-color);
        margin: 12px 0;
    }

    .big-row-tour-result-item .tour-info {
        flex: 1;
        overflow: hidden;
        padding: 12px 8px 12px 12px;
    }
    .big-row-tour-result-item .services-buy {
        padding: 12px 12px 12px 0;
    }

    .big-row-tour-result-item .no-hotel-text {
        font-weight: 500;
        font-size: 14px;
        color: #929292;
    }

    .big-row-tour-result-list .features {
        display: flex;
        align-items: center;
        min-height: 16px;
    }
    .big-row-tour-result-list .features .popover-link {
        margin-right: 12px;
    }

    .big-row-tour-result-list .tour-result-list-image {
        background-size: cover;
        background-repeat: no-repeat;
        background-position: 50%;
        min-width: 80px;
    }

    .big-row-tour-result-list .services-buy {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .big-row-tour-result-list .buy-btn-wrap {
        width: 100%;
    }

    .big-row-tour-result-list .more-hotels {
        font-size: 14px;
        line-height: 16px;
        text-decoration-line: underline;
        color: var(--primary-color);
        cursor: pointer;
        text-align: center;
        margin-bottom: 8px;
    }
    .big-row-tour-result-list .buy-btn-wrap svg {
        transform: rotate(-90deg);
        fill: var(--white-color);
        opacity: .7;
        margin: 2px 0 0 10px;
        transition: all .2s;
    }

    .big-row-tour-result-list .buy-btn-wrap svg.rotate {
        transform: rotate(90deg);
    }

    .big-row-tour-result-list .big-row-tour-result-sub-block {
        background-color: var(--white-color);
        border-radius: 0 0 6px 6px;
        border-top: 1px solid var(--lighten-4-color);
        /*transform: translateY(-3px);*/
        margin-top: -4px;
        display: grid;
        grid-template-columns: repeat(2, 1fr) 700px;
        position: relative;
        z-index: 1;
    }

    .big-row-tour-result-list .big-row-tour-result-sub-block.cancellation {
      grid-template-columns: repeat(2, 1fr) 900px;
    }

    .big-row-tour-result-list .big-row-tour-result-sub-block.cancellation .tour-program-item {
      grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
    }

    .big-row-tour-result-list .big-row-tour-result-sub-block .tour-program-list {
      padding: 12px 20px;
    }

    .big-row-tour-result-list .big-row-tour-result-sub-block .tour-program-item-group {
      position: relative;
    }

    .big-row-tour-result-list .big-row-tour-result-sub-block .tour-program-item-group:not(:last-child) {
      border-bottom: 1px dashed var(--lighten-5-color);
    }

    .big-row-tour-result-list .big-row-tour-result-sub-block .tour-program-item {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
      align-items: center;
      justify-content: space-between;
      padding: 6px 0;
      gap: 5px;
    }

    .big-row-tour-result-list .big-row-tour-result-sub-block .tour-program-item-qui-quo {
      display: grid;
      grid-template-columns: repeat(2, 1fr) 80px;
      align-items: center;
      justify-content: space-between;
      padding: 6px 0;
      gap: 5px;
    }

    .big-row-tour-result-list .big-row-tour-result-sub-block .tour-program-item-qui-quo.isPenalty {
      grid-template-columns: repeat(3, 1fr) 80px;
    }

    .big-row-tour-result-list .big-row-tour-result-sub-block .tour-program-item-qui-quo.isMulti {
      grid-template-columns: repeat(3, 1fr) 80px;
    }

    .big-row-tour-result-list .big-row-tour-result-sub-block .tour-program-item-qui-quo.isPenalty.isMulti {
      grid-template-columns: repeat(4, 1fr) 80px;
    }

    .big-row-tour-result-list .big-row-tour-result-sub-block .tour-program-item .hotel-info-block,
    .big-row-tour-result-list .big-row-tour-result-sub-block .tour-program-item-qui-quo .hotel-info-block {
      flex-wrap: nowrap;
      gap: 12px;
    }


    .big-row-tour-result-list .big-row-tour-result-sub-block .tour-program-item .hotel-info-block .show-price,
    .big-row-tour-result-list .big-row-tour-result-sub-block .tour-program-item-qui-quo .hotel-info-block .show-price {
      margin-top: -5px;
      padding-bottom: 5px;
    }

    .big-row-tour-result-list .big-row-tour-result-sub-block .tour-program-item .hotel-info-block .hotel-info-text,
    .big-row-tour-result-list .big-row-tour-result-sub-block .tour-program-item-qui-quo .hotel-info-block .hotel-info-text {
      min-width: 82px;
      flex: 1;
    }

    .big-row-tour-result-list .big-row-tour-result-sub-block:not(.isMulti) .tour-program-item .sub-hotels-starts-content,
    .big-row-tour-result-list .big-row-tour-result-sub-block:not(.isMulti) .multi-text-open-modal {
      display: none;
    }

    .big-row-tour-result-list .big-row-tour-result-sub-block.isMulti .tour-program-item .sub-hotels-starts-content {
      margin-left: 5px;
      margin-right: 5px;
      display: block;
    }

    .big-row-tour-result-list .big-row-tour-result-sub-block.isMulti .multi-text-open-modal {
      text-decoration: underline;
      cursor: pointer;
      font-size: 13px;
      color: #1C88D6;
      display: block;
    }

    .big-row-tour-result-list .big-row-tour-result-sub-block .tour-program-item .tour-program-list-btn {
      justify-content: space-between;
    }
    .big-row-tour-result-list .big-row-tour-result-sub-block .tour-program-item .tour-program-list-btn.show-btn {
      /* position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0; */
    }
    .features {
      flex-wrap: wrap;
    }
    .base-button {
      white-space: nowrap;
    }
    .quota-line {
      position: absolute;
      bottom: 0;
      width: 25px;
      left: 2px;
      height: 0.1em;
    }

    @media (max-width: 1280px) {
      .price-block {
          padding: 18px 32px;
      }
    }

    @media (min-width: 1600px) {
       .main-block-multiple {
            display: grid;
            grid-template-columns:  repeat(2, 1fr);
            align-items: center;
            column-gap: 30px;
        }
        .main-block .date-map-multiple {
            margin: 0;
        }
        .main-block .food {
            max-width: none;
        }
    }

    .multi-info-block {
      flex-wrap: wrap;
    }

</style>